import { useEffect } from 'react';

interface SEOHeadProps {
  title?: string;
  description?: string;
  ogImage?: string;
  path?: string;
}

const BASE_URL = 'https://sign-safe-reach.lovable.app';

const defaults = {
  title: 'Gelovo Sign - חתימה דיגיטלית',
  description: 'Gelovo Sign - מערכת חתימה דיגיטלית חכמה ומאובטחת',
  ogImage: '/og-image.png',
};

export function SEOHead({
  title = defaults.title,
  description = defaults.description,
  ogImage = defaults.ogImage,
  path = '',
}: SEOHeadProps) {
  useEffect(() => {
    // Update document title
    document.title = title;

    const fullImageUrl = ogImage.startsWith('http') ? ogImage : `${BASE_URL}${ogImage}`;
    const fullUrl = `${BASE_URL}${path}`;

    // Helper to set meta tag
    const setMeta = (attr: string, key: string, content: string) => {
      let el = document.querySelector(`meta[${attr}="${key}"]`) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('name', 'description', description);
    setMeta('property', 'og:title', title);
    setMeta('property', 'og:description', description);
    setMeta('property', 'og:image', fullImageUrl);
    setMeta('property', 'og:url', fullUrl);
    setMeta('property', 'og:type', 'website');
    setMeta('name', 'twitter:title', title);
    setMeta('name', 'twitter:description', description);
    setMeta('name', 'twitter:image', fullImageUrl);

    return () => {
      // Reset to defaults on unmount
      document.title = defaults.title;
      setMeta('name', 'description', defaults.description);
      setMeta('property', 'og:title', defaults.title);
      setMeta('property', 'og:description', defaults.description);
      setMeta('property', 'og:image', `${BASE_URL}${defaults.ogImage}`);
      setMeta('name', 'twitter:title', defaults.title);
      setMeta('name', 'twitter:description', defaults.description);
      setMeta('name', 'twitter:image', `${BASE_URL}${defaults.ogImage}`);
    };
  }, [title, description, ogImage, path]);

  return null;
}
